export const Specialties = [
  'Birth Doula / Labor Support',
  'Postpartum Daytime Care',
  'Postpartum Nighttime Care',
  'Lactation Consultant',
  'Newborn Care Specialist',
  'Sleep Coach/Consultant',
  'Mental Health Support',
  'Hypnotherapy',
  'Sibling Childcare',
  'Doula Training',
  'Physical Therapist (PT)',
  'Trauma Support',
  'Acupuncturist',
  'Chiropractor',
  'Massage Therapist',
  'Nutritionist',
  'Midwife',
  'Occupational Therapist (OT)',
  'Photographer',
  'Registered Dietitian',
  'Speech Pathologist',
  'Night Nanny',
  'Childbirth Educator',
  'Placenta Encapsulation',
  'Cord Blood Banking',
  'IBCLC (International Board Certified Lactation Consultant)',
  'CLC (Certified Lactation Counselor)',
  'CBS (Certified Breastfeeding Specialist)',
  'Registered Nurse',
] as const

export type Specialty = (typeof Specialties)[number]
